/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PcmsHubProviderSnapshot { 
    agencyAddress?: string;
    agencyCity?: string;
    agencyContact?: string;
    agencyDescription?: string;
    agencyEmail?: string;
    agencyName?: string;
    agencyPhone?: string;
    agencyState?: string;
    agencyWebsite?: string;
    agencyZip?: string;
    crdAgencyId?: string;
    crdProgramId?: string;
    pcmsServiceProviderId?: number;
    programAddress?: string;
    programCity?: string;
    programContact?: string;
    programEmail?: string;
    programLanguageEnglish?: boolean;
    programLanguageFrench?: boolean;
    programLanguageOther?: boolean;
    programLanguageSign?: boolean;
    programLanguageSpanish?: boolean;
    programLanguageTagalog?: boolean;
    programLanguageVietnamese?: boolean;
    programName?: string;
    programPhone?: string;
    programRegionCentral?: boolean;
    programRegionEast?: boolean;
    programRegionNorthCoastal?: boolean;
    programRegionNorthInland?: boolean;
    programRegionSouth?: boolean;
    programService?: string;
    programService1624?: boolean;
    programServiceAdult?: boolean;
    programServiceFemale?: boolean;
    programServiceJuvenile?: boolean;
    programServiceMale?: boolean;
    programServiceSubType?: string;
    programState?: string;
    programTreatments?: string;
    programZip?: string;
    providerState?: PcmsHubProviderSnapshot.ProviderStateEnum;
    serviceOtherText?: string;
}
export namespace PcmsHubProviderSnapshot {
    export const ProviderStateEnum = {
        Active: 'ACTIVE',
        Inactive: 'INACTIVE',
        Deleted: 'DELETED'
    } as const;
    export type ProviderStateEnum = typeof ProviderStateEnum[keyof typeof ProviderStateEnum];
}


